import React from "react";
import PropTypes from "prop-types";
import REPLAY_ICON from "@common/images/timer_replay.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";

const ENTER_KEY = 13;

export function ReplayButton(props) {
  const onClick = () => {
    !props.disabled && props.onClick();
  };

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && props.onClick();

  return (
    <Image
      className={props.className}
      src={REPLAY_ICON}
      alt="replay button"
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={props.tabIndex}
    />
  );
}

ReplayButton.propTypes = {
  /**
   * callback function to trigger on click replay
   */
  onClick: PropTypes.func,
};
ReplayButton.defaultProps = {};
